import { types as t } from 'mobx-state-tree';

import { withEnv } from 'models/withEnv';

export const JobRoutes = t
  .model('JobRoutes', {})
  .views(withEnv)
  .actions((self) => ({
    goToDetail: () => self.env.router.push(`/jobs/${self.id}`),
    goToEdit: () => self.env.router.push(`/edit/${self.id}`),
    goToEditForm: () => self.env.router.push(`/edit/${self.id}/form`),
    goToEditRewards: () => self.env.router.push(`/edit/${self.id}/rewards`),
    goToEditAccess: () => self.env.router.push(`/edit/${self.id}/access`),
    goToEditPreview: () => self.env.router.push(`/edit/${self.id}/preview`),
    goToSharingDetail: () => self.env.router.push(`/sharing/${self.id}`),
  }))
  .views((self) => ({
    get promoteUrl() {
      return `/jobs/${self.id}/promote`;
    },
    get integrationsUrl() {
      return `/jobs/${self.id}/integrations`;
    },
    get detailUrl() {
      return `/jobs/${self.id}`;
    },
    get applicantsUrl() {
      return `/jobs/${self.id}/list`;
    },
    get jobInfoUrl() {
      return `/jobs/${self.id}/info`;
    },
    get accessUrl() {
      return `/jobs/${self.id}/access`;
    },
    get pipelineUrl() {
      return `/jobs/${self.id}/pipeline`;
    },
    get statisticsUrl() {
      return `/jobs/${self.id}/statistics`;
    },
  }));
